export default {
  DRW: ["visa.png", "mastercard.png", "amex.png"],
  FM1: ["visa.png", "mastercard.png", "discover.png", "amex.png"],
  IP1: ["visa.png", "mastercard.png", "discover.png", "amex.png", "gpay.png", "Apple_Pay.svg"],
  LAX: ["visa.png", "mastercard.png", "discover.png", "amex.png", "gpay.png", "Apple_Pay.svg"],
  BFS: ["visa.png", "mastercard.png"],
  BHX: ["visa.png", "mastercard.png", "discover.png", "amex.png"],
  BH2: ["visa.png", "mastercard.png", "discover.png", "amex.png"],
  SB2: ["visa.png", "mastercard.png", "discover.png", "amex.png"],
  SB3: ["visa.png", "mastercard.png", "discover.png", "amex.png"],
  SB4: ["visa.png", "mastercard.png", "discover.png", "amex.png"],
  SB5: ["visa.png", "mastercard.png", "discover.png", "amex.png"],

  // ...other brands
  DEFAULT: ["visa.png", "mastercard.png", "discover.png", "amex.png", "gpay.png", "Apple_Pay.svg"],
};